import React from 'react';
import { Box, VStack } from '@chakra-ui/react';
import { motion, AnimatePresence } from 'framer-motion';
import webCore from '@happylife-a/web-core';
import LoadingDots from './LoadingDots';
import ProgressBar from './ProgressBar';

const MotionBox = motion.div;
const MotionText = motion.div;

export default function LoadingAnimation({ isLoading, loadingStage, loadingProgress }) {
  const { t } = webCore.contexts.useTranslation();

  return (
    <AnimatePresence>
      {isLoading && (
        <MotionBox
          w="100%"
          maxW="600px"
          minW="300px"
          style={{ margin: '0 auto' }}
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.3 }}
        >
          <VStack spacing={4} align="center" w="100%" maxW="600px">
            {/* Loading Stage Text */}
            <MotionText
              style={{
                color: 'white',
                fontSize: '16px',
                fontWeight: '500',
                textAlign: 'center',
                width: '100%',
                wordBreak: 'break-word',
              }}
              key={loadingStage}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
            >
              {t(loadingStage)}
            </MotionText>

            {/* Animated Dots */}
            <LoadingDots />

            {/* Progress Bar */}
            <Box minW="300px" w="100%">
              <ProgressBar progress={loadingProgress} />
            </Box>
          </VStack>
        </MotionBox>
      )}
    </AnimatePresence>
  );
}
